import { render, staticRenderFns } from "./FollowDetailDialog.vue?vue&type=template&id=f07b9eb0"
import script from "./FollowDetailDialog.vue?vue&type=script&lang=js"
export * from "./FollowDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports